import { render, staticRenderFns } from "./TheHomeIntroText.vue?vue&type=template&id=f06fa26a&scoped=true&"
import script from "./TheHomeIntroText.vue?vue&type=script&lang=ts&"
export * from "./TheHomeIntroText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06fa26a",
  null
  
)

export default component.exports